export function validatorCard (v, back) {
  let birthday = ''
  let sex = ''
  let C15ToC18 = (c15) => {
    let cID = c15.substring(0, 6) + '19' + c15.substring(6, 15)
    let jy = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
    let iq = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    let it = 0
    for (let i = 0; i < cID.length; i++) {
      it += parseInt(cID.substring(i, i + 1)) * iq[i]
    }
    it %= 11
    cID += jy[it]
    return cID
  }
  let Is18IDCard = (IDNum) => {
    let aCity = {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门',
      91: '国外'
    }
    let iSum = 0
    let sID = IDNum
    if (!/^\d{17}(\d|x)$/i.test(sID)) {
      return false
    }
    sID = sID.replace(/x$/i, 'a')
    if (aCity[parseInt(sID.substr(0, 2))] == null) {
      return false
    }
    let sBirthday = sID.substr(6, 4) + '-' + sID.substr(10, 2) + '-' + sID.substr(12, 2)
    let d = new Date(sBirthday.replace(/-/g, '/'))
    let dm = d.getMonth() + 1
    let dd = d.getDate()
    if (sBirthday !== (d.getFullYear() + '-' + (dm > 9 ? dm : '0' + dm) + '-' + (dd > 9 ? dd : '0' + dd))) return false
    birthday = sBirthday
    sex = sID.substr(16, 1)
    for (let i = 17; i >= 0; i--) iSum += (Math.pow(2, i) % 11) * parseInt(sID.charAt(17 - i), 11)
    if (iSum % 11 !== 1) return false
    return true
  }
  if (!back) {
    return v.length === 15 ? Is18IDCard(C15ToC18(v)) : Is18IDCard(v)
  } else {
    if (v.length === 15 ? Is18IDCard(C15ToC18(v)) : Is18IDCard(v)) {
      back(birthday, sex)
    }
  }
}

export function saveLocal (id, key, val) {
  let store = window.localStorage._store_
  if (!store) {
    store = {}
    store[id] = {}
  } else {
    store = JSON.parse(store)
    if (!store[id]) {
      store[id] = {}
    }
  }
  store[id][key] = val
  window.localStorage._store_ = JSON.stringify(store)
}

export function readLocal (id, key, defaults) {
  let store = window.localStorage._store_
  if (!store) {
    return defaults
  }
  store = JSON.parse(store)[id]
  if (!store) {
    return defaults
  }
  let ret = store[key]
  return ret || defaults
}

export function formatNumber (val, num) { // num 为0时表示要返回整数
  val = typeof val === 'number' ? val.toString() : val
  if (typeof val === 'string') {
    if (num === 0) {
      return val.replace(/[^\d]/g, '')
    } else {
      num = num || 3
      if (val === '') return ''
      val = val.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/^\./g, '').replace(/\./, '$#$').replace(/\./g, '').replace('$#$', '.')
      let reg = new RegExp('(\\d+)(\\.?\\d{0,' + num + '}).*$')
      val = val.replace(reg, '$1$2')
      let idx = val.indexOf('.')
      if (idx !== -1 && idx < val.length) {
        let v1 = val.split('.')[0]
        v1 = parseFloat(v1)
        val = v1 + '.' + val.split('.')[1]
      } else {
        val = val !== '' ? parseFloat(val) : ''
      }
      return val
    }
  } else {
    return ''
  }
}

export function getUuid () { // 生成唯一id
  let S4 = () => {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  let guid = () => {
    return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4())
  }
  return guid() + '-ey'
}

// 图片压缩
export function compress (file, obj, callback) {
  try {
    const image = new Image()
    image.src = URL.createObjectURL(file)
    image.onload = function () {
      let w = image.width
      let h = image.height
      const scale = w / h
      w = obj.width || w
      h = obj.height || (w / scale)
      let quality = 0.7 // 默认图片质量
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const anw = document.createAttribute('width')
      anw.nodeValue = w
      const anh = document.createAttribute('height')
      anh.nodeValue = h
      canvas.setAttributeNode(anw)
      canvas.setAttributeNode(anh)
      ctx.drawImage(image, 0, 0, w, h)
      if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
        quality = obj.quality
      }
      const data = canvas.toDataURL('image/jpeg', quality)
      callback(convertBase64UrlToBlob(data))
    }
  } catch (e) {
    console.log('压缩失败')
  }
}

export function convertBase64UrlToBlob (urlData) {
  // base转图片类型
  const bytes = window.atob(urlData.split(',')[1])
  const ab = new ArrayBuffer(bytes.length)
  const ia = new Uint8Array(ab)
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i)
  }
  return new Blob([ab], { type: 'image/png' })
}

export function floatObj (a, b, type) {
  // js精度丢失修复
  let isInteger = (obj) => {
    return Math.floor(obj) === obj
  }
  let toInteger = (floatNum) => {
    let ret = { times: 1, num: 0 }
    let isNegative = floatNum < 0
    if (isInteger(floatNum)) {
      ret.num = floatNum
      return ret
    }
    let strFi = floatNum + ''
    let dotPos = strFi.indexOf('.')
    let len = strFi.substr(dotPos + 1).length
    let times = Math.pow(10, len)
    let intNum = parseInt(Math.abs(floatNum) * times + 0.5, 10)
    ret.times = times
    if (isNegative) {
      intNum = -intNum
    }
    ret.num = intNum
    return ret
  }
  let operation = (a, b, op) => {
    let o1 = toInteger(a)
    let o2 = toInteger(b)
    let n1 = o1.num
    let n2 = o2.num
    let t1 = o1.times
    let t2 = o2.times
    let max = t1 > t2 ? t1 : t2
    let result = null

    switch (op) {
      case 'add':
        if (t1 === t2) {
          result = n1 + n2
        } else if (t1 > t2) {
          result = n1 + n2 * (t1 / t2)
        } else {
          result = n1 * (t2 / t1) + n2
        }
        result = result / max
        break
      case 'subtract':
        if (t1 === t2) {
          result = n1 - n2
        } else if (t1 > t2) {
          result = n1 - n2 * (t1 / t2)
        } else {
          result = n1 * (t2 / t1) - n2
        }
        result = result / max
        break
      case 'multiply':
        result = (n1 * n2) / (t1 * t2)
        break
      case 'divide':
        let nT = (t2 / t1).toString()
        let dotPos = nT.indexOf('.')
        if (dotPos !== -1) {
          let len = nT.substr(dotPos + 1).length
          let times = Math.pow(10, len)
          let nR = (n1 / n2) * (t2 / t1) * times
          let nS = nR.toString()
          let idx = nS.indexOf('.')
          if (idx === -1) {
            result = result / times
          } else {
            let nLen = nS.substr(idx + 1).length
            let nTimes = Math.pow(10, nLen)
            nS = nS.replace(/\./, '')
            nS = parseInt(nS)
            result = nS / (nTimes * times)
          }
        } else {
          result = (n1 / n2) * (t2 / t1)
        }
        break
    }
    return result
  }
  return operation(a, b, type).toFixed(2)
}

export function mantissaMoney (val, type, comma = true) {
  if (type) {
    type = parseInt(type)
    // 示例：120.12345
    switch (type) {
      case 1: // 四舍五入到分 120.12
        val = Math.round(floatObj(val, 100, 'multiply'))
        val = floatObj(val, 100, 'divide')
        break
      case 2: // 四舍五入到角 120.1
        val = Math.round(floatObj(val, 10, 'multiply'))
        val = floatObj(val, 10, 'divide')
        break
      case 3: // 四舍五入到元 120
        val = Math.round(val)
        break
      case 4: // 见分进角  120.2
        val = Math.ceil(floatObj(val, 10, 'multiply'))
        val = floatObj(val, 10, 'divide')
        break
      case 5: // 见分舍去,见角进元  121
        val = Math.floor(floatObj(val, 10, 'multiply'))
        val = floatObj(val, 10, 'divide')
        val = Math.ceil(val)
        break
      case 6: // 见厘进分  120.13
        val = Math.ceil(floatObj(val, 100, 'multiply'))
        val = floatObj(val, 100, 'divide')
        break
      case 7: // 见角舍去  120
        val = Math.floor(val)
        break
      case 8: // 见厘舍去  120.12
        val = Math.floor(floatObj(val, 100, 'multiply'))
        val = floatObj(val, 100, 'divide')
        break
      case 9: // 四舍五入到厘  120.123
        val = Math.round(floatObj(val, 1000, 'multiply'))
        val = floatObj(val, 1000, 'divide')
        break
      case 10: // 四舍五入到小数点后4位  120.1235
        val = Math.round(floatObj(val, 10000, 'multiply'))
        val = floatObj(val, 10000, 'divide')
        break
    }
  }
  if (comma) {
    if (val) {
      let s = val.toString()
      let s1 = ''
      let isInt = true
      if (s.indexOf('.') !== -1) {
        s1 = s.substring(0, s.indexOf('.'))
        isInt = false
      } else {
        s1 = s
      }
      let it = s1.replace(/\B(?=(?:\d{3})+$)/g, ',')
      let dt = isInt ? '' : s.substring(s.indexOf('.'), s.length)
      return it + dt
    } else {
      return (val === 0 || val === '0') ? '0.00' : ''
    }
  } else {
    return val
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js